// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentSavedOrdersStyles } from "@tps/App/Widgets/RecentSavedOrders/RecentSavedOrders";
import { sharedRecentWidgetsStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

recentSavedOrdersStyles.centeringWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `
}

recentSavedOrdersStyles.container = {
    ...sharedRecentWidgetsStyles.container,
};

recentSavedOrdersStyles.headingWrapper = {
    ...sharedRecentWidgetsStyles.headingWrapper,
};

recentSavedOrdersStyles.widgetTitle = {
    ...sharedRecentWidgetsStyles.widgetTitle,
};

recentSavedOrdersStyles.viewAllLink = {
    ...sharedRecentWidgetsStyles.viewAllLink,
};

recentSavedOrdersStyles.noResults = {
    ...sharedRecentWidgetsStyles.noResult,
};
